export default "__VITE_ASSET__DbTPKuGQ__"